export default [
  {
    path: "/publisherNoRecharge",
    name: "publisherNoRecharge",
    component: () => import("@/views/publisher/noRecharge.vue"),
    meta: {
      title: "route.publish-not-activated",
      crumbs: "route.publish-not-activated-crumb",
      isLogin: true,
    },
  },
  {
    path: "/publisher",
    name: "publisherIndex",
    redirect: "/publisher/store", // 重定向到我的发布
    component: () => import("@/views/publisher/navigationPublish.vue"),
    // component: () => import("@/views/publisher/index.vue"),
    meta: {
      title: "route.content-publish",
      crumbs: "route.content-publish-crumb",
      isLogin: true,
      // 主侧栏直接读取 sidebar 元数据生成一级导航。
      sidebar: { label: "内容发布", labelKey: "route.content-publish", icon: "Content", order: 30 },
    },
    children: [
      {
        path: "/publisher/list",
        name: "publisherList",
        component: () => import("@/views/publisher/manage/list.vue"),
        meta: {
          title: "route.publish-list",
          crumbs: "route.publish-list-crumb",
          isLogin: true,
          series: "publisher",
          sidebar: { label: "发布列表", labelKey: "route.publish-list", icon: "Publish list", order: 20 },
        },
      },
      {
        path: "/publisher/store",
        name: "publisherStore",
        component: () => import("@/views/publisher/manage/store.vue"),
        meta: {
          title: "route.publish-list",
          crumbs: "route.publish-post-crumb",
          isLogin: true,
          needBackBtn: false,
          parentName: "publisherList",
          series: "publisher",
          // 发帖入口在二级导航中放首位，点击内容发布默认进入这里。
          sidebar: { label: "内容发布", labelKey: "route.publish-post", icon: "Editor", order: 10 },
        },
      },
      {
        path: "/publisher/calendar",
        name: "publisherCalendar",
        component: () => import("@/views/publisher/calendar/index.vue"),
        meta: {
          title: "route.publish-calendar",
          crumbs: "route.publish-calendar-crumb",
          isLogin: true,
          needBackBtn: false,
          parentName: "publisherList",
          series: "publisher",
          sidebar: { label: "发布日历", labelKey: "route.publish-calendar", icon: "Release Calendar", order: 30 },
        },
      },
      {
        path: "/publisher/draft",
        name: "publisherDraft",
        component: () => import("@/views/publisher/draft/index.vue"),
        meta: {
          title: "route.publish-draft",
          crumbs: "route.publish-draft-crumb",
          isLogin: true,
          needBackBtn: false,
          parentName: "publisherList",
          series: "publisher",
          sidebar: { label: "发布草稿", labelKey: "route.publish-draft", icon: "Inbox", order: 40 },
        },
      },
    ],
  },
];
